export enum ReceiptType {
  RECEIPT = "RECEIPT",
  REFUND = "REFUND",
  PAYOUT = "PAYOUT",
  INVOICE = "INVOICE",
  ORDER = "ORDER",
}
